<div ng-controller="LabelController as ctrl" class="modal-view label-management">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>